import Vue from 'vue/dist/vue.min.js';
import store from './store';
import EventBus from './event-bus';
import axios from 'axios';
import fpodb from '../../../db.json';
import { debounce } from './misc';
import { Accordion, SelectedFiltersComponent, Checkbox, Pagination } from './filter-components';

const ProductCatalog = () => {

    let catalog = document.querySelectorAll('.product-catalog');

    const productCatalogConstructor = (id) => {
        Vue.component('product-catalog-template', {
            data: function() {
                return {
                    data: {
                        currentPage: 1, //current page #
                        totalPages: null, //total returns pages
                        totalResults: null, //total results
                        shownResults: null, //total shown items
                        filtersVisible: null, //are filters visible
                        filterAreaVisible: true, //is filter area (including unit toggler and btns) visible
                        filters: [],
                        products: [],
                        results: [],
                        emailDocs: [], //for emailing
                        savedDocs: [], //bookmarked items
                        savedDocsLabel: null, //label for saved docs
                        savedDocsOnly: null,
                        isMobile: null,
                        nextActive: null,
                        prevActive: null,
                        // apiUrl: null, //for api call
                        urlParams: null, //for deeplinking in-browser
                        shareAll: false,
                        selectedUnit: null,
                        usLabel: '',
                        metricLabel: '',
                        store: store,
                        viewProductLabel: null,
                        class: 'product-catalog',

                    }
                }
            },
            components: {
                'filter-accordion-template': Accordion,
                'selectedFilters': SelectedFiltersComponent,
                'checkbox-item': Checkbox,
                'pagination': Pagination
            },
            computed: {
                computedIsMobile: function() {
                    return store.state.isMobile;
                },
                saved: function() {
                    return store.state.favorites.productId[0] == "" ? store.state.favorites.productId.slice(1) : store.state.favorites.productId;
                },
                computedUnit: function() {
                    return store.state.units;
                },
                pageRange: function() {
                    if (this.data.totalResults > 9) {
                        if (this.data.currentPage == 1) {
                            return `1-${this.data.shownResults}`;
                        } else if (this.data.currentPage == this.data.totalPages ) {
                            return `${this.data.totalResults - this.data.shownResults + 1}-${this.data.totalResults}`;
                        } else {
                            return `${(this.data.shownResults * (this.data.currentPage - 1)) + 1}-${this.data.shownResults * this.data.currentPage}`;
                        }
                    } else {
                        return this.data.shownResults;
                    }
                },
            },
            watch: {
                computedUnit: function() {
                    this.data.selectedUnit = this.computedUnit;
                    // console.log("unit changed");
                    this.getUrl();
                    // this.updateHistory();
                },
                saved: function() {
                    this.data.savedDocs = this.saved;

                    // remove saved only filter if no saved items
                    if (this.saved.length == 0) {
                        let index = this.data.filters.map((e) => {
                            return e.value
                        }).indexOf('savedDownloads');
                        if (index > -1) {
                            this.data.filters.splice(index,1);
                        }
                    }
                },
                computedIsMobile: function() {
                    this.data.isMobile = this.computedIsMobile;
                    this.data.filtersVisible = !this.computedIsMobile ? true : this.data.filtersVisible;
                },
                "data.filters": function() {
                    this.getResults(); // handle api call
                    // this.updateHistory(); // handle history record

                    // set savedDocsOnly value
                    let savedOnly = this.data.filters.find(item => {
                        return item.type == "savedProducts";
                    });
                    this.data.savedDocsOnly = savedOnly ? savedOnly.value : null;
                },
                "data.currentPage": function() {
                    if (this.data.currentPage == 1) {
                        this.data.nextActive = true;
                        this.data.prevActive = false;
                    } else if (this.data.currentPage == this.data.totalPages) {
                        this.data.nextActive = false;
                        this.data.prevActive = true;
                    } else {
                        this.data.nextActive = true;
                        this.data.prevActive = true;
                    }

                    this.getResults();
                    // this.updateHistory();
                },
                "data.totalResults": function() {
                    this.initPages();
                }
            },
            methods: {
                toggleFilters() {
                    // console.log("clicked");
                    if (this.data.isMobile) {
                        // console.log("is mobile");
                        this.data.filtersVisible = !this.data.filtersVisible;
                    }
                },
                updateFilters(el, e, type) {
                    if (el !== this.data.class) {
                        return;
                    }
                    var type = type;
                    var value = encodeURIComponent(e.currentTarget.value);
                    var label = e.currentTarget.parentNode.innerText;
                    var checked = e.currentTarget.checked;
                    this.data.currentPage = 1; //reset page to 1

                    if (checked) {
                        switch(type) {
                            case "measuringMedium":
                                let measureFilter = this.data.filters.map((e) => {
                                    return e.type
                                });
                                // console.log(measureFilter);
                                if (measureFilter.indexOf('measuringMedium') > -1) {
                                    let index = measureFilter.indexOf('measuringMedium');
                                    this.data.filters.splice(index,1);
                                    this.data.filters = [...this.data.filters, 
                                        {"value": value, 
                                        "type": type, 
                                        "name": label
                                    }];
                                } else {
                                    this.data.filters = [...this.data.filters, 
                                        {"value": value, 
                                        "type": type, 
                                        "name": label}];
                                }
                                break;
                            case "savedProducts":
                                this.data.filters = [...this.data.filters, 
                                    {"value": checked, 
                                    "type": type, 
                                    "name": label}];
                                break;
                            default: 
                                this.data.filters = [...this.data.filters, 
                                    {"value": value, 
                                    "type": type, 
                                    "name": label}];
                        }

                    } else {
                        let index = this.data.filters.map((e) => {
                            return e.value
                        }).indexOf(value);
                        // console.log("INDEX", index);
                        this.data.filters.splice(index,1);
                    }
                    console.log("updateFilters - this.data.filters=", this.data.filters);

                },
                updateRangeFilter(entry) {
                    this.data.currentPage = 1; //reset page to 1 when filters changed
                    // console.log(entry);
                    // allow only once instance of filter type at once for ranges
                    let types = this.data.filters.map((e) => {
                        return e.type
                    });
                    if (types.indexOf(entry.type) > -1) {
                        let index = types.indexOf(entry.type);

                        if (this.data.filters[index].value == entry.value && this.data.filters[index].type == entry.type) {
                            // if old and new entries are the same, do nothing
                            return;
                        } else {
                            // only update filters if new entry values differ
                            this.data.filters.splice(index,1);
                            this.data.filters = [...this.data.filters, entry];
                        }

                    } else {
                        this.data.filters = [...this.data.filters, entry];
                    }
                    // this.data.filters = [...this.data.filters, entry];
                },
                // removes specific filter
                removeFilter(el, value, type) {
                    if (el !== this.data.class) { return; }
                    if (value) {
                        let index = this.data.filters.map((e) => {
                            return e.value
                        }).indexOf(value);
                        if (index > -1) {
                            this.data.filters.splice(index,1);
                        }
                    } else {
                        let index = this.data.filters.map((e) => {
                            return e.type
                        }).indexOf(type);
                        // console.log("remove", index);
                        if (index > -1) {
                            this.data.filters.splice(index,1);
                        }
                    }
                },
                // clears filters
                removeAll() {
                    this.data.filters = [];
                    this.data.currentPage = 1; //reset page to 1
                },  
                
                getUrl() {
                    let savedParams = this.data.savedDocs.toString();
                    let unitParams = this.computedUnit;

                    let marketParams = this.data.filters.filter(item => {
                        return item.type == "market"
                    }).map(item => {
                        return item.value;
                    }).toString();

                    let productCatParams = this.data.filters.filter(item => {
                        return item.type == "productCategory"
                    }).map(item => {
                        return item.value;
                    }).toString();
                    let subparams = this.data.filters.filter(item => {
                        return item.type == "subparam"
                    }).map(item => {
                        return item.value;
                    }).toString();

                    let productTypeParams = this.data.filters.filter(item => {
                        return item.type == "productType"
                    }).map(item => {
                        return item.value;
                    }).toString();

                    let productLineParams = this.data.filters.filter(item => {
                        return item.type == "productLine"
                    }).map(item => {
                        return item.value;
                    }).toString();

                    let measuringParams = this.data.filters.filter(item => {
                        return item.type == "measuringMedium"
                    }).map(item => {
                        return item.value;
                    }).toString();

                    let savedDocumentsTrueParams = () => {
                        var savedOnly = this.data.filters.find(item => {
                            return item.type == "savedProducts";
                        })
                        if (savedOnly) {
                            return savedOnly.value;
                        } else {
                            return false;
                        }
                    }
   
                    let pageParams = this.data.currentPage;

                    let sizeMinParams = this.data.filters.filter(item => {
                        return item.type == "sizeMin"
                    }).map(item => {
                        return item.value;
                    }).toString();
                    let sizeMaxParams = this.data.filters.filter(item => {
                        return item.type == "sizeMax"
                    }).map(item => {
                        return item.value;
                    }).toString();

                    let tempMinParams = this.data.filters.filter(item => {
                        return item.type == "temperatureMin"
                    }).map(item => {
                        return item.value;
                    }).toString();
                    let tempMaxParams = this.data.filters.filter(item => {
                        return item.type == "temperatureMax"
                    }).map(item => {
                        return item.value;
                    }).toString();

                    let pressureMinParams = this.data.filters.filter(item => {
                        return item.type == "pressureMin"
                    }).map(item => {
                        return item.value;
                    }).toString();
                    let pressureMaxParams = this.data.filters.filter(item => {
                        return item.type == "pressureMax"
                    }).map(item => {
                        return item.value;
                    }).toString();

                    let flowRangeMinParams = this.data.filters.filter(item => {
                        return item.type == "flowRangeMin"
                    }).map(item => {
                        return item.value;
                    }).toString();
                    let flowRangeMaxParams = this.data.filters.filter(item => {
                        return item.type == "flowRangeMax"
                    }).map(item => {
                        return item.value;
                    }).toString();
                    let flowRangeType = this.data.filters.filter(item => {
                        return item.type == "flowRangeMax" || item.type == "flowRangeMin"
                    }).map(item => {
                        return item.flowRangeType;
                    }).toString();

                    this.data.urlParams = `${unitParams !== "" ? "&units=" + unitParams : ""}${marketParams !== "" ? "&market=" + marketParams : ""}${productCatParams !== "" ? "&productCategory=" + productCatParams : ""}${productTypeParams !== "" ? "&productType=" + productTypeParams : ""}${productLineParams !== "" ? "&productLine=" + productLineParams : ""}${measuringParams !== "" ? "&measuringMedium=" + measuringParams : ""}&savedProducts=${savedDocumentsTrueParams()}${subparams !== "" ? "&subparam=" + subparams : ""}&page=${pageParams}`;

                    // console.log(apiUrl);
                    // this.data.apiUrl = apiUrl;
                },
                getResults() {
                    // let apiUrl = "api/documents?";
                    this.getUrl();
                    let baseUrl = window.productCatalogAPIUrl;
                    let apiUrl = `${baseUrl}${baseUrl.indexOf('?') > -1 ? '' : '?'}`;
                    // let apiUrl = "http://localhost:3003/products"; //from json-server
                    // let apiUrl = "http://localhost:3003/productsTest"; //from json-server

                    let self = this;

                    let savedDocumentsTrueParams = () => {
                        var savedOnly = this.data.filters.find(item => {
                            return item.type == "savedProducts";
                        })
                        if (savedOnly) {
                            return true;
                        } else {
                            return false;
                        }
                    }

                    var market = [];
                    var productCategory = [];
                    var productType = [];
                    var productLine = [];
                    var subparam = [];

                    this.data.filters.map((item) => {
                        switch(item.type) {
                            case "market":
                                market.push(item.value);
                                break;
                            case "productCategory":
                                productCategory.push(item.value);
                                break;
                            case "productLine":
                                productLine.push(item.value);
                                break;
                            case "productType":
                                productType.push(item.value);
                                break;
                            case "subparam":
                                subparam.push(item.value);
                            default:
                                return;
                        }
                    });

                    const getValue = (param) => {
                        let filter = this.data.filters.find((item) => {
                            return item.type === param;
                        });
                        return filter ? filter.value : null;
                    }

                    const getFlowRangeType = () => {
                        let filter = this.data.filters.find((item) => {
                            return item.type === "flowRangeMin" || item.type === "flowRangeMax";
                        });
                        return filter ? filter.flowRangeType : null;
                    }

                    let axiosParams = {
                        // language: null,
                        units: this.computedUnit,
                        market: market.join('|') == "" ? null : decodeURIComponent(market.join('|')),
                        productCategory: productCategory.join('|') == "" ? null : decodeURIComponent(productCategory.join('|')),
                        productType: productType.join('|') == "" ? null : decodeURIComponent(productType.join('|')),
                        productLine: productLine.join('|') == "" ? null : decodeURIComponent(productLine.join('|')),
                        sizeMin: getValue('sizeMin'),
                        sizeMax: getValue('sizeMax'),
                        flowRangeType: getFlowRangeType(),
                        flowRangeMin: getValue('flowRangeMin'),
                        flowRangeMax: getValue('flowRangeMax'),
                        measuringMedium: getValue('measuringMedium') == null ? null : decodeURIComponent(getValue('measuringMedium')),
                        temperatureMin: getValue('temperatureMin'),
                        temperatureMax: getValue('temperatureMax'),
                        pressureMin: getValue('pressureMin'),
                        pressureMax: getValue('pressureMax'),
                        savedProducts: savedDocumentsTrueParams(),
                        subparam: subparam.join('|') == "" ? null : decodeURIComponent(subparam.join('|')),
                        saved: this.data.savedDocs.join('|') == "" ? null : this.data.savedDocs.join('|').charAt(0) == "," ? this.data.savedDocs.join('|').slice(1) : this.data.savedDocs.join('|'),
                        page: this.data.currentPage,
                        pageSize: 9,
                    }

                    console.log(axiosParams);

                    axios.get(apiUrl, {
                        params: {
                            ...axiosParams
                        }
                        })
                        .then(function(response) {
                            // console.log(response);
                            self.data.results = response.data.results;  
                            self.data.totalResults = response.data.totalResults ? response.data.totalResults : 0;
                            self.data.shownResults = response.data.results ? response.data.results.length : 0;
                            self.data.viewProductLabel = response.data.viewProductLabel;
                            //console.log(response.data);
                        })
                        .catch(function(error) {
                            console.log(error);
                        });
                },
                changePage(dir) {
                    if (dir == "prev" && this.data.currentPage !== 1) {
                        this.data.currentPage--;
                    } else if (dir == "next" && this.data.currentPage !== this.data.totalPages) {
                        this.data.currentPage++;
                    } else {
                        return;
                    }
                    EventBus.$emit('scroll-to-top', this.data.class);
                },
                updateEmailDocs(data) {
                    let item = this.data.emailDocs.find(item => {
                        return item.id == data.id;
                    });

                    if (!item) {
                        this.data.emailDocs = [...this.data.emailDocs, data];
                    } else {
                        this.data.emailDocs.splice(this.data.emailDocs.indexOf(item),1);
                    }
                },
                //update history record when filters change
                updateHistory() {
                    let url = `${window.location.pathname}?${this.data.urlParams}`;
                    if (history.state == null || history.state !== url) {
                        history.pushState(url,"",url);
                    }
                },
                // handle deep linking on history change
                deeplink() {
                    let params = window.location.search.substr(1).split("&").filter(item => {
                        return item != ""
                    });
                    // console.log(params);
                    // this.data.filters = []; //clear filters array first

                    var initFilters = [];

                    params.forEach(param => {
                        let type = param.slice(0, param.indexOf('='));
                        let content = param.slice(param.indexOf('=') + 1);
                        // console.log("TYPE",type);
                        // console.log("CONTENT", content);

                        let entry = {}
                        if (type == "page") {
                            this.data.currentPage = parseInt(content);
                        } else if (type == "units") {
                            this.data.selectedUnit = content;
                        } else if (type == "savedProducts") {
                            if (content == "false" || content == false) {
                                return;
                            } else {
                                entry = {
                                    "type": type,
                                    "value": true,
                                    "name": this.data.savedDocsLabel
                                }

                                initFilters = [
                                    ...initFilters,
                                    entry
                                ]
                            }
                        } else if (content.indexOf(',') > -1) {
                            let contentArray = content.split(',');
                            contentArray.forEach(item => {
                                entry = {
                                    "type": type,
                                    "value": item,
                                    "name": decodeURIComponent(item)
                                }

                                initFilters = [
                                    ...initFilters,
                                    entry
                                ]
                            });
                        } else {
                            entry = {
                                "type": type,
                                "value": content,
                                "name": decodeURIComponent(content)
                            }

                            initFilters = [
                                ...initFilters,
                                entry
                            ]
                        }

                        this.data.filters = initFilters;
                        
                        // console.log(this.initFilters);

                    });
                },
                toggleUnits() {
                    store.commit('setUnits');
                },
                scrollToTop(el) {
                    if (el !== this.data.class) {return;}
                    let top = this.$el.querySelector('.product-catalog__area-cards').getBoundingClientRect().top + window.scrollY - 100;
                    // console.log(top);
                    setTimeout(function() {
                        window.scrollTo({
                            top: top,
                            behavior: 'smooth'
                        });
                    }, 500);
                },
                initPages() {
                    // based on total result count, divide by 10 to get total pages needed
                    // math ceil to round up
                    // set active for prev/next based on current page
                    // 9 = page size
                    this.data.totalPages = Math.ceil(this.data.totalResults / 9);
                    this.data.prevActive = this.data.currentPage !== 1 ? true : false;
                    this.data.nextActive = this.data.currentPage !== this.data.totalPages ? true : false;
                },
                init() {
                    // init data variables
                    this.data.isMobile = store.state.isMobile;
                    this.data.savedDocs = store.state.favorites.productId[0] == "" ? store.state.favorites.productId.slice(1) : store.state.favorites.productId;
                    this.data.selectedUnit = store.state.units;
                    this.data.filtersVisible = this.data.isMobile ? false : true; //init show/hide filters if/is mobile
                    this.data.filterAreaVisible = parseInt(this.data.totalResults) <= 10 ? false : true; // hide filters if less then 10 initial results
                    this.data.shareAll = parseInt(this.data.totalResults) <= 5 ? true : false; // enable "share all" if 5 of less results
                    this.data.usLabel = this.$refs.unitToggler.dataset.usLabel;
                    this.data.metricLabel = this.$refs.unitToggler.dataset.metricLabel;

                    // init eventbus listeners
                    EventBus.$on('updateFilters', (el, e, type) => {
                        this.updateFilters(el, e, type);
                    });
                    EventBus.$on('updateRangeFilter', (entry) => {
                        this.updateRangeFilter(entry);
                    });
                    EventBus.$on('remove-filter', (el, value, type) => {
                        this.removeFilter(el, value, type);
                    });
                    EventBus.$on('change-page-to', (el, num) => {
                        if (el !== this.data.class) {return;};
                        this.data.currentPage = num;
                    });
                    EventBus.$on('email-docs', (data) => {
                        this.updateEmailDocs(data);
                    });
                    EventBus.$on('scroll-to-top', (el) => {
                        this.scrollToTop(el);
                    });

                    // init initial results
                    if (window.defaultFilter) {
                        this.data.filters.push(window.defaultFilter);
                    }
                    this.data.results = window.initialProductApiResults.results;
                    this.data.totalResults = window.initialProductApiResults ? window.initialProductApiResults.totalResults : 0;
                    this.data.shownResults = window.initialProductApiResults.results ? window.initialProductApiResults.results.length : 0;
                    this.data.viewProductLabel = window.initialProductApiResults ? window.initialProductApiResults.viewProductLabel : null;

                    // this.data.results = fpodb.products.results;
                    // this.data.totalResults = fpodb.products.totalResults;
                    // this.data.shownResults = fpodb.products.results ? fpodb.products.results.length : 0;
                    // this.data.viewProductLabel = fpodb.products.viewProductLabel;
                    
                    // window.onpopstate = () => {
                    //     this.deeplink();
                    // }
                }
            },
            mounted() {
                this.init();
                this.initPages();
                // for deeplinking
                // if (window.location.search) {
                //     this.$nextTick(() => {
                //         this.deeplink();
                //     });
                // }
            }
        });
        
        // results list
        Vue.component('product-results-list', {
            props: ['data'],
            data: function() {
                return {
                    type: "product"
                }
            },
            template: `
            <div class="product-catalog__cards-content" :data="data">
                <product-results-item v-for="(result, index) in data.results" :content="result" :key="index" :index="index" :data="data"/>
            </div>
            `,
            methods: {
            },

            mounted() {

            }
        });

        // single results item
        Vue.component('product-results-item', {
            props: ['data', 'content', 'index'],
            data: function() {
                return {
                    isChecked: false,
                    isBookmarked: false,
                    id: this.content.id || null
                }
            },
            computed: {
                saved: function() {
                    return store.state.favorites.productId;
                },
                taggingMeta: function() {
                    return JSON.stringify({
                        "type": "layer",
                        "category": "Preview Card",
                        "productLine": this.content.brand,
                        "label": this.content.productName ? this.content.productName.replace('<p>', '').replace('</p>','') : null,
                        "no": this.index < 10 ? `0${this.index + 1}` : (this.index + 1).toString()
                    })
                }
            },
            watch: {
                saved: function() {
                    this.isBookmarked = this.saved.includes(this.id) ? true : false;
                },
                "content": function() {
                    this.id = this.content.id || null;
                    this.isBookmarked = this.saved.includes(this.id) ? true : false;
                }
            },
            template: `
            <div class="catalog-card" :data="data" :class="{'hide-bookmark': (data.savedDocsOnly === true) && (isBookmarked === false)}" data-tag-trigger="click" :data-tag-meta="taggingMeta">
                <div class="catalog-card__row">
                    <div class="catalog-card__area catalog-card__area-util">
                        <div class="catalog-card__util-bookmark">
                            <span class="catalog-card__bookmark" :class="{active: isBookmarked}" :data-product-id="content.id" ref="bookmark" v-on:click="handleBookmark" data-tag-trigger="click" data-tag-meta='{"type": "layer", "category": "Product", "action": "Favorite"}'></span>
                        </div>
                    </div>
                    
                    <div class="catalog-card__area catalog-card__area-header">
                        <div class="catalog-card__image-container">
                            <a :href="content.url" class="catalog-card__link">
                                <img class="catalog-card__image" :src="content.productImageUrl" :alt="content.productImageUrlAltText">
                            </a>
                        </div>
                        <img :src="content.brandImageUrl" :alt="content.brandImageUrlAltText" class="catalog-card__logo">
                        <a :href="content.url" v-html="content.productName" class="catalog-card__title"></a>
                    </div>

                    <div class="catalog-card__area catalog-card__area-stats">

                        <div class="catalog-card__stat" v-for="(spec, index) in content.stats" :key="index" :data="data">
                            <div class="catalog-card__stat-label" v-html="spec.label">{{spec.label}}</div>
                            <div class="catalog-card__stat-value">
                                <div class="unit-metric " v-if="data.selectedUnit === 'metric'" v-html="spec.valueMetric">{{spec.valueMetric}}</div>
                                <div class="unit-us" v-if="data.selectedUnit === 'us'" v-html="spec.valueImperial">{{spec.valueImperial}}</div>
                            </div>
                        </div>
                        
                    </div>

                    <div class="catalog-card__area catalog-card__area-cta">
                        <a :href="content.url" class="button tertiary-button"><span class="button-text">{{data.viewProductLabel}}</span> <span class="button-icon"></span></a>
                    </div>
                </div>
            </div>
            `,
            methods: {
                handleBookmark() {
                    store.commit('updateFavorites', {
                        id: this.id,
                        type: "productId",
                        action: this.isBookmarked ? "remove" : "add"
                    });
                    store.dispatch('checkFavorites');
                }
            },
            mounted() {
                // this.id = this.$refs.bookmark.dataset.productId;
                // console.log("saved",this.saved);
                this.isBookmarked = this.saved.includes(`${this.id}`) ? true : false;
            }
        });

        Vue.component('email-docs', {
            props: ['data'],
            data: function() {
                return {
                    mailto: null,
                    mailtoAll: null
                }
            },
            watch: {
                "data.emailDocs": function() {
                    let mailto = "mailto:?subject=Badger%20Meter%20Document%20Links&body=";
                    this.data.emailDocs.forEach(item => {
                        mailto = `${mailto}${encodeURIComponent(item.name)}: ${item.url}%0D%0A`;
                    });
                    this.mailto = mailto;
                }
            },
            methods: {
                shareAll() {
                    let mailto = "mailto:?subject=Badger%20Meter%20Document%20Links&body=";
                    this.data.results.forEach(item => {
                        mailto = `${mailto}${encodeURIComponent(item.name)}: ${item.url}%0D%0A`;
                    });
                    this.mailtoAll = mailto;
                }
            },
            mounted() {
                if (parseInt(this.data.totalResults) <= 5) {
                    this.shareAll();
                }
            }
        });

        Vue.component('min-max', {
            props: ['data'],
            data: function() {
                return {
                    minValue: null, //final values to send to api
                    minValueRange: null, // model for range slider
                    minValueInput: null, // model for input field
                    maxValue: null, //final values to send to api
                    maxValueRange: null, // model for range slider
                    maxValueInput: null, // model for input field

                    usMin: null,
                    usMax: null,
                    usStep: null,
                    metricMin: null,
                    metricMax: null,
                    metricStep: null,

                    currentMin: null,
                    currentMax: null,
                    currentStep: null,
                    styles: null,

                    type: null,
                    currentUnit: null,
                    label: null
                }
            },
            watch: {
                "data.filters": function() {
                    let types = this.data.filters.map((e) => {
                        return e.type
                    });
                    if (!(types.indexOf(`${this.type}Min`) > -1)) {
                        this.minValue = null;
                    }
                    if (!(types.indexOf(`${this.type}Max`) > -1)) {
                        this.maxValue = null;
                    }
                },
                "data.selectedUnit": function() {
                    this.initCurrentUnits();
                    this.initUnitLabel();
                    // reset selectors when units change
                    this.maxValue = null;
                    this.minValue = null;
                    this.minValueRange = this.currentMin;
                    this.maxValueRange = this.currentMax;

                    // clear inputs and input filters when changing units
                    EventBus.$emit('remove-filter', this.data.class, null, `${this.type}Min`);
                    EventBus.$emit('remove-filter', this.data.class, null, `${this.type}Max`);
                },
                "minValue": function() {
                    // if at max value, set to null for 'no min' and remove filter
                    // if value exceeds min or max range, set to one step under max value
                    if (this.minValue == this.currentMin || this.minValue == "") {
                        this.minValue = null;
                        EventBus.$emit('remove-filter', this.data.class, null, `${this.type}Min`);
                    } else if (parseFloat(this.minValue) < parseFloat(this.currentMin) || parseFloat(this.minValue) > parseFloat(this.currentMax)) {
                        // this.minValue = parseFloat(this.currentMin) === 0 ? 0 : (parseFloat(this.currentMin) - parseFloat(this.currentStep)).toString();
                        this.minValue = null;
                        EventBus.$emit('remove-filter', this.data.class, null, `${this.type}Min`);
                    }

                    this.updateFilters("Min");
                    this.minValueRange = this.minValue == null ? this.currentMin : this.minValue;
                    this.minValueInput = this.minValue;

                },
                "maxValue": function() {
                    // if at max value, set to null for 'no max' and remove filter
                    // if value exceeds min or max range, set to one step under max value
                    if (this.maxValue == this.currentMax || this.maxValue == "") {
                        this.maxValue = null;
                        EventBus.$emit('remove-filter', this.data.class, null, `${this.type}Max`);
                    } else if (parseFloat(this.maxValue) > parseFloat(this.currentMax) || parseFloat(this.maxValue) < parseFloat(this.currentMin)) {
                        // this.maxValue = (parseFloat(this.currentMax) - parseFloat(this.currentStep)).toString();
                        this.maxValue = null;
                        EventBus.$emit('remove-filter', this.data.class, null, `${this.type}Max`);
                    }

                    this.updateFilters("Max");
                    this.maxValueRange = this.maxValue == null ? this.currentMax : this.maxValue;
                    this.maxValueInput = this.maxValue;
                },
                "maxValueRange": function() {
                    // condition to prevent dragging slider beyond the valid range
                    if (parseFloat(this.maxValueRange) <= parseFloat(this.minValueRange)) {
                        this.maxValueRange = (parseFloat(this.minValueRange) + parseFloat(this.currentStep)).toString();
                    }

                    this.maxValueInput = this.maxValueRange == this.currentMax ? null : this.maxValueRange;
                    this.initStyles();

                },
                "minValueRange": function() {
                    // condition to prevent dragging slider beyond the valid range
                    if (parseFloat(this.minValueRange) >= parseFloat(this.maxValueRange)) {
                        this.minValueRange = (parseFloat(this.maxValueRange) - parseFloat(this.currentStep)).toString();
                    }

                    this.minValueInput = this.minValueRange == this.currentMin ? null : this.minValueRange;
                    this.initStyles();
                }
            },
            methods: {
                updateFilters: debounce(function(type) {
                    // console.log("type:", type);
                    let entry = {
                        name: `${type} ${this.label}: ${type == "Min" ? this.minValue : this.maxValue} ${this.currentUnit}`,
                        value: type == "Min" ? this.minValue : this.maxValue,
                        type: `${this.type}${type}`
                    }
                    // console.log(entry);
                    if (entry.value !== null) {
                        EventBus.$emit('updateRangeFilter', entry);
                    }

                }, 500),
                handleRange: debounce(function(e, type) {
                        let _t = e.target;
                        var min = type == "min" ? _t.value : this.minValue;
                        var max = type == "max" ? _t.value : this.maxValue;    
                        // console.log("MAX", max);
                        if (type == "min") {
                            if (parseFloat(min) >= parseFloat(max)) {
                                min = (parseFloat(max) - parseFloat(this.currentStep)).toString();
                            }
                        } else if (type == "max") {
                            if (parseFloat(max) <= parseFloat(min)) {
                                max = (parseFloat(min) + parseFloat(this.currentStep)).toString();
                            }
                        }

                        this.minValue = min;
                        this.maxValue = max;

                        this.minValueInput = this.minValueInput !== this.minValue && this.minValue !== null ? this.minValue : this.minValueInput;
                        this.maxValueInput = this.maxValueInput !== this.maxValue && this.maxValue !== null ? this.maxValue : this.maxValueInput;

                    }, 500),
                initEvents() {
                    this.$refs.rangeMin.addEventListener('input', e => {
                        this.handleRange(e, 'min');
                      }, false);
                      this.$refs.rangeMax.addEventListener('input', e => {
                        this.handleRange(e, 'max');
                      }, false);
                },
                initMinMax() {
                    // US
                    this.usMin = this.$refs.rangeMin.dataset.usMin;
                    this.usMax = this.$refs.rangeMin.dataset.usMax;
                    this.usStep = this.$refs.rangeMin.dataset.usStep;

                    // METRIC
                    this.metricMin = this.$refs.rangeMin.dataset.metricMin;
                    this.metricMax = this.$refs.rangeMin.dataset.metricMax;
                    this.metricStep = this.$refs.rangeMin.dataset.metricStep;

                    this.initCurrentUnits();
                },
                initCurrentUnits() {
                    // CURRENT UNITS
                    this.currentMin = this.data.selectedUnit == 'us' ? this.usMin : this.metricMin;
                    this.currentMax = this.data.selectedUnit == 'us' ? this.usMax : this.metricMax;
                    this.currentStep = this.data.selectedUnit == 'us' ? this.usStep : this.metricStep;
                    this.initStyles();
                },
                initUnitLabel() {
                    let unitLabels = this.$refs.rangeMin.dataset.units ? JSON.parse(this.$refs.rangeMin.dataset.units) : null;
                    this.currentUnit = unitLabels[this.data.selectedUnit];
                },
                initStyles() {
                    this.styles = `--a: ${this.minValueRange === null ? this.currentMin : this.minValueRange}; --b: ${this.maxValueRange === null ? this.currentMax : this.maxValueRange}; --min: ${this.currentMin}; --max: ${this.currentMax}`;
                },
            },
            mounted() {
                this.initMinMax();
                this.initEvents();
                // this.initUnitLabel();
                this.$nextTick(() => {                    
                    // init slider positions
                    this.minValueRange = this.data.selectedUnit == "us" ? this.$refs.rangeMin.dataset.usMin : this.$refs.rangeMin.dataset.metricMin;
                    this.maxValueRange = this.data.selectedUnit == "us" ? this.$refs.rangeMin.dataset.usMax : this.$refs.rangeMin.dataset.metricMax;

                    this.type = this.$refs.rangeMin.dataset.type;
                    this.label = this.$refs.rangeMin.dataset.label;
                });

                

            }

        });

        Vue.component('min-max-flowrange', {
            props: ['data'],
            data: function() {
                return {
                    minValue: null, //final values
                    minValueRange: null, // model for range slider
                    minValueInput: null, // model for input field
                    maxValue: null, //final values
                    maxValueRange: null,
                    maxValueInput: null,

                    min: null,
                    // gpmMax: null,
                    // gpmStep: null,
                    // mhMax: null,
                    // mhStep: null,
                    // lpmMax: null,
                    // lpmStep: null,

                    currentMin: 0,
                    currentMax: null,
                    currentStep: null,
                    styles: null,

                    type: null,
                    currentUnit: null,

                    medium: null, //selected measuring medium
                    label: null // display name for filter
                }
            },
            watch: {
                "data.filters": function() {
                    let types = this.data.filters.map((e) => {
                        return e.type
                    });
                    if (!(types.indexOf(`${this.type}Min`) > -1)) {
                        this.minValue = null;
                    }
                    if (!(types.indexOf(`${this.type}Max`) > -1)) {
                        this.maxValue = null;
                    }
                    if (types.indexOf('measuringMedium') > -1) {
                        this.medium = this.data.filters.find((item) => {
                            return item.type == 'measuringMedium';
                        }).name.toLowerCase();
                    } else {
                        this.medium = null;
                    }
                }, 
                "medium": function() {
                    this.currentUnit = null;
                    EventBus.$emit('remove-filter', this.data.class,  null, 'flowRangeMin');
                    EventBus.$emit('remove-filter', this.data.class,  null, 'flowRangeMax');
                    this.initOptions();
                },
                "currentUnit": function() {
                    if (this.currentUnit !== "null" && this.currentUnit !== null) {
                        this.$nextTick(() => {
                            // this.initMinMax();
                            this.initStyles();
                            this.initEvents();
                            this.type = this.$refs.rangeMin.dataset.type;

                            // clear final values
                            this.minValue = null;
                            this.maxValue = null;

                            // set default slide range positions
                            this.minValueRange = this.min;
                            this.maxValueRange = this.currentMax;

                            // console.log('init',this.label);
                            this.label = this.label !== null ? this.label : this.$refs.rangeMin ? this.$refs.rangeMin.dataset.label : null;
                            // console.log('final',this.label);
                        });

                    } else {
                        // if no unit selected, remove flow range filters
                        EventBus.$emit('remove-filter', this.data.class, null, 'flowRangeMin');
                        EventBus.$emit('remove-filter', this.data.class, null, 'flowRangeMax');
                    }
                },
                "minValue": function() {
                    if (this.minValue == this.currentMin || this.minValue == "") {
                        this.minValue = null;
                        EventBus.$emit('remove-filter', this.data.class, null, 'flowRangeMin');
                    } else if (parseFloat(this.minValue) < parseFloat(this.currentMin) || parseFloat(this.minValue) > parseFloat(this.currentMax)) {
                        // this.minValue = (parseFloat(this.currentMin) - parseFloat(this.currentStep)).toString();
                        this.minValue = null;
                        EventBus.$emit('remove-filter', this.data.class, null, 'flowRangeMin');
                    }

                    // this.initStyles();
                    this.minValueRange = this.minValue == null ? this.min : this.minValue;
                    this.minValueInput = this.minValue;
                    if (this.minValue !== null) {
                        this.updateFilters("Min");
                    }
                },
                "maxValue": function() {
                    if (this.maxValue == this.currentMax || this.maxValue == "") {
                        this.maxValue = null;
                        EventBus.$emit('remove-filter', this.data.class, null, 'flowRangeMax');
                    } else if (parseFloat(this.maxValue) > parseFloat(this.currentMax) || parseFloat(this.maxValue) < parseFloat(this.currentMin)) {
                        // this.maxValue = (parseFloat(this.currentMax) - parseFloat(this.currentStep)).toString();
                        this.maxValue = null;
                        EventBus.$emit('remove-filter', this.data.class, null, 'flowRangeMax');
                    }

                    // this.initStyles();
                    this.maxValueRange = this.maxValue == null ? this.currentMax : this.maxValue;
                    this.maxValueInput = this.maxValue;
                    if (this.maxValue !== null) {
                        this.updateFilters("Max");
                    }
                },
                // globally selected us/metric unit
                "data.selectedUnit": function() {
                    // clear current flow range selection
                    this.currentUnit = "null";

                    // show/hide options for relevant units
                    // this.initUnits();
                    this.initOptions();
                },

                "maxValueRange": function() {
                    // condition to prevent dragging slider beyond the valid range
                    if (parseFloat(this.maxValueRange) <= parseFloat(this.minValueRange)) {
                        this.maxValueRange = (parseFloat(this.minValueRange) + parseFloat(this.currentStep)).toString();
                    }

                    this.maxValueInput = this.maxValueRange == this.currentMax ? null : this.maxValueRange;
                    this.initStyles();

                },
                "minValueRange": function() {
                    // condition to prevent dragging slider beyond the valid range
                    if (parseFloat(this.minValueRange) >= parseFloat(this.maxValueRange)) {
                        this.minValueRange = (parseFloat(this.maxValueRange) - parseFloat(this.currentStep)).toString();
                    }

                    this.minValueInput = this.minValueRange == this.currentMin ? null : this.minValueRange;
                    this.initStyles();
                }
            },
            methods: {
                updateFilters: debounce(function(type) {
                    //console.log("type:", type);
                    let entry = {
                        name: `${type} ${this.label}: ${type == "Min" ? this.minValue : this.maxValue} ${this.currentUnit}`,
                        value: type == "Min" ? this.minValue : this.maxValue,
                        type: `${this.type}${type}`,
                        flowRangeType: this.currentUnit
                    }
                    // console.log(entry);
                    if (entry.value !== null) {
                        EventBus.$emit('updateRangeFilter', entry);
                    }

                }, 500),
                handleRange: debounce(function(e, type) {
                    let _t = e.target;
                    var min = type == "min" ? _t.value : this.minValue;
                    var max = type == "max" ? _t.value : this.maxValue;    
                    if (type == "min") {
                        if (parseFloat(min) >= parseFloat(max)) {
                            min = (parseFloat(max) - parseFloat(this.currentStep)).toString();
                        }
                    } else if (type == "max") {
                        if (parseFloat(max) <= parseFloat(min)) {
                            max = (parseFloat(min) + parseFloat(this.currentStep)).toString();
                        }
                    }

                    this.minValue = min;
                    this.maxValue = max;

                    this.minValueInput = this.minValueInput !== this.minValue && this.minValue !== null ? this.minValue : this.minValueInput;
                    this.maxValueInput = this.maxValueInput !== this.maxValue && this.maxValue !== null ? this.maxValue : this.maxValueInput;
                },500),
                initEvents() {
                    this.$refs.rangeMin.addEventListener('input', e => {
                        this.handleRange(e, 'min');
                      }, false);
                      this.$refs.rangeMax.addEventListener('input', e => {
                        this.handleRange(e, 'max');
                      }, false);
                },
                initOptions() {
                    this.$el.querySelectorAll('option').forEach((item) => {
                        let unit = item.dataset.unitType;
                        let flow = item.dataset.flowType ? item.dataset.flowType.toLowerCase() : null;

                        if (this.medium == null) {
                            if (item.getAttribute('value') == "null") {
                                return;
                            } else if (unit == this.data.selectedUnit) {
                                item.style.display = "block";
                            } else {
                                item.style.display = "none";
                            }
                        } else {
                            if (item.getAttribute('value') == "null") {
                                return;
                            } else if (flow.includes(this.medium) && unit == this.data.selectedUnit) {
                                item.style.display = "block";
                            } else {
                                item.style.display = "none";
                            }
                        }
                    });
                },
                initStyles() {
                    this.styles = `--a: ${this.minValueRange === null ? this.currentMin : this.minValueRange}; --b: ${this.maxValueRange === null ? this.currentMax : this.maxValueRange}; --min: ${this.currentMin}; --max: ${this.currentMax}`;
                },
                selectUnit(e) {
                    this.currentUnit = e.target.value == "null" ? null : e.target.value; //set selected unit
                    if (e.target.value !== "null" && e.target.value !== null) {
                        let data = JSON.parse(this.$el.querySelector(`option[value="${e.target.value}"]`).dataset.flowData); //get min/max data for selected unit
    
                        // set min/max data for current unit
                        this.min = data.min;
                        this.currentMax = data.max;
                        this.currentMin = data.min;
                        this.currentStep = data.step;
                    }

                },
                initUnits() {
                    let unit = this.data.selectedUnit;
                    // console.log(unit);
                    this.$el.querySelectorAll(`option`).forEach((item) => {
                        // console.log(item);
                        if (item.getAttribute('value') == "null") {
                            return;
                        } else if (item.dataset.unitType !== unit) {
                            item.style.display = "none";
                        } else {
                            item.style.display = "block";
                        }
                    });
                }
            },
            mounted() {
                this.$nextTick(() => {
                    // this.initUnits();
                    this.initOptions();
                    // this.label = this.$refs.rangeMin ? this.$refs.rangeMin.dataset.label : null;
                });
            }
        });

        Vue.component('radio-item', {
            props: ['data'],
            data: function() {
                return {
                    type: "measuringMedium",
                    id: null,
                    isChecked: null,
                    selectedRadio: null
                }
            },
            watch: {
                "data.filters": function() {
                    this.checkState();
                }
            },
            methods: {
                updateFilters(el, e, type) {
                    // console.log("e", e);
                    // console.log("type", type);
                    EventBus.$emit('updateFilters', el, e, type);
                },
                checkState() {
                    let item = this.data.filters.find(el => {
                        return el.value == this.id;
                    });
                    this.isChecked = item ? true : false;
                    this.selectedRadio = item ? decodeURIComponent(item.value) : null;
                },
            },
            mounted() {
                this.id = encodeURIComponent(this.$refs.input.value);
            }
        });

        new Vue({
            el: `.product-catalog-${id}`,
            store: store
        }).$mount(`.product-catalog-${id}`, true);
    }

    // multiHandleRange();
    if (catalog.length > 0) {
        catalog.forEach((item, index) => {
            item.classList.add(`product-catalog-${index}`);
            productCatalogConstructor(index);
        })
    }

}

export default ProductCatalog;